// Upgrade prices
export const UPGRADE_PRICES = {
    VOCAL_LESSON: 5000,
    DANCE_PRACTICE: 5000,
    STYLIST_CONSULT: 5000,
    RESTORE_SPIRIT: 1000,
    MYSTIC_WARD: 500000,
    WARD_MAINTENANCE: 100000,
    ENDORSEMENT: 1000000,
    RELAX_AT_CAFE: 5000,
    HAN_TONIC: 500,
    HAN_CONSULTATION: 1000,
    BATHHOUSE_ENTRY: 500
};
